import { FC } from "react";
import useCheckIfMobile from "helpers/check-if-mobile";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { colorMain } from "./colors";
import { ReactComponent as Icon } from "assets/i.svg";

const Container = styled.sup`
  display: inline-block;
  margin: 5px;
  text-align: center;
  vertical-align: super;
`;

const IconWrapper = styled.a`
  cursor: help;
  color: ${colorMain};

  > svg {
    width: 15px;
  }
`;

interface TooltipType {
  tip: string;
  id: string;
}

export const Tooltip: FC<TooltipType> = ({ tip, id }) => {
  const isMobile = useCheckIfMobile();

  return (
    <Container>
      <IconWrapper data-tip={tip} data-for={id}>
        <Icon />
      </IconWrapper>
      <ReactTooltip
        id={id}
        place={isMobile ? "left" : "right"}
        type="dark"
        effect="solid"
        className="tooltip"
      />
    </Container>
  );
};
